/**
 * Update Cookie with String.
 * Multipurpose function to update Cookie with string value.
 *
 * @param name Name of the cookie
 * @param value
 * @param days If null expiration by session.
 * @param cookieSettings Note if you are using same cookie that has been set in PHP also,
 * remember to pass the same configs as in PHP.
 */
export function updateCookieWithString(name, value, days = null, cookieSettings = {}) {

// Use destructuring to pull cookieSettings values, providing safe defaults
  // These defaults ensure the cookie is readable and writable on most paths.
  const {
    path = '/',
    domain = '',
    secure = (window.location.protocol === 'https:'),
    samesite = 'Lax'
  } = cookieSettings;

  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  const encodedValue = encodeURIComponent(value);

  // 1. Conditionally add the Secure flag
  // Use cookieSettings.secure if provided, otherwise default based on current protocol
  const secureFlag = secure ? ' Secure' : '';

  // 2. Conditionally add the Domain attribute (must be exact to update)
  const domainAttribute = domain ? `; domain=${domain}` : '';

  // 3. Construct the final cookie string.
  // The Path and SameSite attributes must exactly match the existing cookie to update it.
  const finalCookieString =
    `${name}=${encodedValue}${expires}; path=${path}; SameSite=${samesite}${domainAttribute}${secureFlag}`;

  document.cookie = finalCookieString;
}
